import { render, staticRenderFns } from "./GrainTypeDetail.vue?vue&type=template&id=752ae9a0&scoped=true"
import script from "./GrainTypeDetail.vue?vue&type=script&lang=js"
export * from "./GrainTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./GrainTypeDetail.vue?vue&type=style&index=0&id=752ae9a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752ae9a0",
  null
  
)

export default component.exports